import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

const SOCKET_URL = "https://api.twoffers.com/ws";

class WebSocketService {
  static instance = null;
  stompClient = null;
  listeners = [];
  latestBids = {}; // store latest bid per property

  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  connect() {
    if (this.stompClient && this.stompClient.connected) return;

    const socket = new SockJS(SOCKET_URL);
    this.stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 3000,
      debug: (msg) => console.log("STOMP DEBUG:", msg),
    });

    this.stompClient.onConnect = () => {
      console.log("STOMP Connected");
      this.subscribeToBids();
      this.subscribeToErrors();
    };

    this.stompClient.onStompError = (err) => {
      console.error("STOMP Error:", err);
    };

    this.stompClient.activate();
  }

  subscribeToBids() {
    if (!this.stompClient || !this.stompClient.connected) return;

    if (this.bidsSubscription) this.bidsSubscription.unsubscribe();

    this.bidsSubscription = this.stompClient.subscribe("/topic/bids", (message) => {
      const bidData = JSON.parse(message.body);

      // store latest bid
      this.latestBids[bidData.propertyId] = bidData;

      // notify all listeners
      this.listeners.forEach((cb) => cb(bidData));
    });
  }

  // NEW METHOD: Subscribe to WebSocket Errors
subscribeToErrors() {
  if (!this.stompClient || !this.stompClient.connected) return;

  // Unsubscribe previous error subscription if any
  if (this.errorSubscription) this.errorSubscription.unsubscribe();

  // Subscribe to error topic
  this.errorSubscription = this.stompClient.subscribe("/user/topic/errors", (message) => {
    const errorData = message.body;

    console.error("Received WebSocket Error:", errorData);

    // store latest error
    this.latestError = errorData;

    // notify all error listeners
    if (this.errorListeners && this.errorListeners.length > 0) {
      this.errorListeners.forEach((cb) => cb(errorData));
    }
  });
}

// Method to register error listeners
addErrorListener(callback) {
  if (!this.errorListeners) this.errorListeners = [];
  this.errorListeners.push(callback);
}

// Method to remove specific error listener
removeErrorListener(callback) {
  if (!this.errorListeners) return;
  this.errorListeners = this.errorListeners.filter((cb) => cb !== callback);
}

  // --- simplified listener for anywhere ---
  getData(callback) {
    if (typeof callback === "function") {
      this.listeners.push(callback);

      // send all latest bids immediately
      Object.values(this.latestBids).forEach((bid) => callback(bid));
    }
  }

  sendBid(propertyId, bidAmount, buyerId) {
    if (!this.stompClient || !this.stompClient.connected) {
      console.warn("STOMP not connected");
      return;
    }

    const bidMessage = {
      propertyId: Number(propertyId),
      bidAmount: String(bidAmount),
      buyerId: Number(buyerId),
    };

    this.stompClient.publish({
      destination: "/app/bid.send",
      body: JSON.stringify(bidMessage),
    });

    console.log("Bid sent:", bidMessage);
  }
}

const socketService = WebSocketService.getInstance();
socketService.connect(); // connect globally once
export default socketService;































// Todo : Don't Delete This

// import SockJS from "sockjs-client";
// import { Client } from "@stomp/stompjs";

// const SOCKET_URL = "https://api.twoffers.com/ws";

// class WebSocketService {
//   static instance = null;
//   stompClient = null;
//   listeners = []; // callbacks for incoming bids

//   static getInstance() {
//     if (!WebSocketService.instance) {
//       WebSocketService.instance = new WebSocketService();
//     }
//     return WebSocketService.instance;
//   }

//   // Connect and subscribe to bids
//   connect() {
//     if (this.stompClient && this.stompClient.connected) return;

//     const socket = new SockJS(SOCKET_URL);
//     this.stompClient = new Client({
//       webSocketFactory: () => socket,
//       reconnectDelay: 3000, // auto reconnect
//       debug: (msg) => console.log("STOMP DEBUG:", msg),
//     });

//     this.stompClient.onConnect = (frame) => {
//       console.log("✅ STOMP Connected:", frame);
//       this.subscribeToBids();
//     };

//     this.stompClient.onStompError = (err) => {
//       console.error("❌ STOMP Error:", err);
//     };

//     this.stompClient.activate();
//   }

//   disconnect() {
//     if (this.stompClient) {
//       this.stompClient.deactivate();
//       console.log("⚠️ STOMP Disconnected");
//     }
//   }

//   // Subscribe to /topic/bids
//   subscribeToBids() {
//     if (!this.stompClient || !this.stompClient.connected) return;

//     // unsubscribe previous subscription if exists
//     if (this.bidsSubscription) this.bidsSubscription.unsubscribe();

//     this.bidsSubscription = this.stompClient.subscribe("/topic/bids", (message) => {
//       const bidData = JSON.parse(message.body);
//       console.log("Bid Received:", bidData);

//       // notify all listeners
//       this.listeners.forEach((cb) => cb(bidData));
//     });
//   }

//   // Register component/page to receive updates
//   addBidListener(callback) {
//     this.listeners.push(callback);
//   }

//   removeBidListener(callback) {
//     this.listeners = this.listeners.filter((cb) => cb !== callback);
//   }

//   // Send bid to backend
// sendBid(propertyId, bidAmount, buyerId) {
//   if (!this.stompClient || !this.stompClient.connected) {
//     console.warn("⚠️ Cannot send bid, STOMP not connected");
//     return;
//   }

//   try {
//     const bidMessage = {
//       propertyId: Number(propertyId),
//       bidAmount: String(bidAmount),
//       buyerId: Number(buyerId),
//     };

//     // backend mapping: @MessageMapping("/bid.send")
//     this.stompClient.publish({
//       destination: "/app/bid.send",
//       body: JSON.stringify(bidMessage),
//     });

//     console.log("✅ Bid sent:", bidMessage);
//   } catch (e) {
//     console.error("❌ sendBid error:", e);
//   }
// }

// }

// const socketService = WebSocketService.getInstance();
// export default socketService;
